<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="contents"><a id="page_7"></a>Contents</h2>
<p class="toc"><a class="nounder" href="#/xhtml/foreword#foreword">Foreword</a></p>
<p class="toca">by E. Peter Earnest, Former Senior CIA National Clandestine Service Officer and Executive Director of the International Spy Museum</p>
<p class="toc"><a class="nounder" href="#/xhtml/intro#intro">Introduction</a></p>
<p class="toc-p"><a class="nounder" href="#/xhtml/part1#part1">Part I: Building the Skills</a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch01#ch01">Chapter 1:</a></p>
<p class="toca"><a class="nounder" href="#/xhtml/ch01#ch01">What Do We Mean by “Truth”?</a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch02#ch02">Chapter 2:</a></p>
<p class="toca"><a class="nounder" href="#/xhtml/ch02#ch02">Vetting the Source</a></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">Chapter 3:</span></p>
<p class="toca"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">Building Rapport</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">Chapter 4:</span></p>
<p class="toca"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">The Art and Science of Motivating Conversation</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">Chapter 5:</span></p>
<p class="toca"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">Managing the Exchange</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">Chapter 6:</span></p>
<p class="toca"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">Analyzing the Information</span></p>
<p class="toc-p"><a id="page_8"></a><span class="nounder" href="#/xhtml/part2#part2" title="Link target outside of Sample">Part II: Skills in Action</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">Chapter 7:</span></p>
<p class="toca"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">Applying the Skills to People Who Want to Tell the Truth</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">Chapter 8:</span></p>
<p class="toca"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">Applying the Skills to People Who Hope to Hide Something</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample">Chapter 9:</span></p>
<p class="toca"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample">Applying the Skills to Hostile Sources</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample">Chapter 10:</span></p>
<p class="toca"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample">Self-Assessment</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/notes#notes" title="Link target outside of Sample">Chapter Notes</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/glo#glo" title="Link target outside of Sample">Glossary</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/index#index" title="Link target outside of Sample">Index</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/contributors#contributors" title="Link target outside of Sample">About the Contributors From the Intelligence Community</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/author#author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6ab276b4